import React from 'react'
import { useQuery } from 'react-query'
import { initTransactionForOthersLoans } from 'services/loans'

export default function useSetInitPayment(
    id: number,
    amount: number,
    selectedInstallment: number
) {
    const { data, isLoading } = useQuery(
        [
            'init-transaction-for-others-in-loans',
            id,
            amount,
            selectedInstallment,
        ],
        initTransactionForOthersLoans
    )
    return { data, isLoading }
}
